import { types, RouterActionsType, IRouter } from '../types/router'

export const initialState: IRouter = {
  pathToRedirect: undefined,
}

export const router = (
  state = initialState,
  action: RouterActionsType
): IRouter => {
  switch (action.type) {
    case types.ROUTER_PUSH:
      return { ...state, pathToRedirect: action.pathToRedirect }
    case types.ROUTER_CLEAR:
      return initialState
    default:
      return state
  }
}
